module.exports = __webpack_public_path__ + "media/images/citiesBannerGraphicSM-485203df.svg";